// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_1VZP8","cardTitle":"wzdeM","cardItem":"_1kmhx","cardItemTitle":"-fnaZ","cardItemValue":"_2NTPp"};